import React, { Fragment } from "react";
import {
  CustomContainer,
  IconWrapper1,
  IconWrapper2,
  IconWrapper3,
  SidePanelCardTitle
} from "../styled/SidePanel.style.js";
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import PropTypes from "prop-types";

export default function SidePanelCard({ title, icon, clicked, leftAlign, nonShow, isVisibleAsGreen, visibilityClicked, onClickVisibility, iconInfo, ...props }) {
  return (
    <Fragment>
      <CustomContainer clicked={clicked}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconWrapper1 clicked={clicked}>
            {icon ? <img src={icon} alt="logo1" width="17" /> : <div style={{ width: "17px" }}></div>}
          </IconWrapper1>
          <SidePanelCardTitle clicked={clicked} leftAlign={leftAlign} >
            {title}
          </SidePanelCardTitle>

        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          {iconInfo?.showIcon && (
            <IconWrapper1 onClick={iconInfo?.onClickIcon}>
              {icon ? <img src={iconInfo?.icon} alt="logo2" width="17px" style={{ opacity: 0.5 }} /> : <div style={{ width: "17px" }}></div>}
            </IconWrapper1>
          )}
          {nonShow && (
            <IconWrapper2 clicked={!visibilityClicked} onClick={onClickVisibility} data-testid="IconWrapper2-test" >
              {isVisibleAsGreen ? ((visibilityClicked && <VisibilityOutlinedIcon style={{ color: clicked ? "white" : "green", fontSize: 17 }} />) ||
                (!visibilityClicked && <VisibilityOffOutlinedIcon style={{ color: clicked ? "white" : "green", fontSize: 17 }} />)
              ) : <VisibilityOffOutlinedIcon style={{ color: clicked ? "white" : "grey", fontSize: 17 }} />}
            </IconWrapper2>
          )}
          <IconWrapper3 clicked={clicked} {...props} data-testid="IconWrapper3-test">
            {clicked ? <KeyboardArrowUpIcon style={{ fontSize: 23 }} /> : <KeyboardArrowDownSharpIcon style={{ fontSize: 23 }} />}
          </IconWrapper3>
        </div>
      </CustomContainer>
    </Fragment>
  );
}

SidePanelCard.propTypes = {
  onClick: PropTypes.func,
  checked: PropTypes.bool,
};

SidePanelCard.defaultProps = {
  onClick: undefined,
  checked: false,
};